import type { Auth, User } from 'firebase/auth';
import { useCallback, useEffect, useState } from 'react';

import type { FirebaseListenerResult, FirebaseListernerState } from './types';

export function useFirebaseListener(auth: Auth): FirebaseListenerResult {
  const [state, setUser] = useState<FirebaseListernerState>({ loading: true, user: null });

  const handleAuthChange = useCallback((user: User | null) => {
    setUser({ loading: false, user });
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(handleAuthChange);

    return () => {
      unsubscribe();
    };
  }, [auth, handleAuthChange]);

  const reset = useCallback(() => {
    setUser({ loading: true, user: null });
  }, []);

  return {
    loading: state.loading,
    reset,
    user: state.user,
  };
}
